<template>
  <footer class="bg-body-tertiary py-3 mt-auto">
    <div class="container-fluid">
      <div class="text-center">
        <span class="text-body-secondary">© {{ currentYear }} Gestionale Pareri Admin. Tutti i diritti riservati.</span>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'FooterTemplate',
  computed: {
    currentYear() {
      return new Date().getFullYear()
    }
  }
}
</script>

<style scoped>
footer {
  border-top: 1px solid rgba(0,0,0,.1);
}
</style>
